import categoryAssociateIcon from 'assets/image/category_associate.svg';
import categoryBossIcon from 'assets/image/category_boss.svg';
import categoryBusinessIcon from 'assets/image/category_business.svg';
import categoryCompanyIcon from 'assets/image/category_company.svg';
import categoryOpportunityIcon from 'assets/image/category_opportunity.svg';
import categoryOrganizationIcon from 'assets/image/category_organization.svg';
import categoryRecognitionIcon from 'assets/image/category_recognition.svg';
import categoryTreatmentIcon from 'assets/image/category_treatment.svg';
import { QuestionCategoryTypes } from 'types/backend/engagementSurvey/result';
import { BracketTypes } from '../types';

export const PHASE_LABEL = {
  before: '診断前',
  progressing: '診断中',
  after: '完了',
  suspended: '停止中',
} as BracketTypes;

export const QUESTION_CATEGORY_TYPES: QuestionCategoryTypes[] = [
  'company',
  'business',
  'organization',
  'boss',
  'associate',
  'treatment',
  'recognition',
  'opportunity',
];

export const QUESTION_CATEGORY_SUMALLY_LABEL = [
  {
    categoryType: 'company',
    label: '会社理解・共感',
  },
  {
    categoryType: 'business',
    label: '事業理解・共感',
  },
  {
    categoryType: 'organization',
    label: '組織理解・共感',
  },
  {
    categoryType: 'boss',
    label: '上司との関係',
  },
  {
    categoryType: 'associate',
    label: '仲間との関係',
  },
  {
    categoryType: 'treatment',
    label: '業務環境・待遇',
  },
  {
    categoryType: 'recognition',
    label: '承認欲求',
  },
  {
    categoryType: 'opportunity',
    label: '成長機会',
  },
];

interface QuestionCategoryDetailLabelType {
  company: CategoryDetailLabelTypes;
  business: CategoryDetailLabelTypes;
  organization: CategoryDetailLabelTypes;
  boss: CategoryDetailLabelTypes;
  associate: CategoryDetailLabelTypes;
  treatment: CategoryDetailLabelTypes;
  recognition: CategoryDetailLabelTypes;
  opportunity: CategoryDetailLabelTypes;
}

export interface CategoryDetailLabelTypes {
  label: string;
  categoryType: QuestionCategoryTypes;
  children: CategoryChildLabelType[];
}

export interface CategoryChildLabelType {
  title: string;
  questions: QuestionLabelType[];
}

export interface QuestionLabelType {
  body: string;
}

export const QUESTION_CATEGORY_DETAIL_LABEL: QuestionCategoryDetailLabelType = {
  company: {
    categoryType: 'company',
    label: '会社理解・共感',
    children: [
      {
        title: '会社への理解・共感',
        questions: [
          {
            body: '会社の戦略や⽬標を理解していますか？',
          },
          {
            body: '会社の戦略や目標に共感していますか？',
          },
        ],
      },
      {
        title: '会社基盤への理解や安心',
        questions: [
          {
            body: '会社の財務状況を理解していますか？',
          },
          {
            body: '会社の財務状況に対して安心していますか？',
          },
        ],
      },
      {
        title: '経営陣への理解・共感',
        questions: [
          {
            body: '経営陣は会社の戦略やビジョンについて発信していますか？',
          },
          {
            body: 'あなたは、経営陣が発信する会社の戦略やビジョンに共感していますか？',
          },
        ],
      },
    ],
  },
  business: {
    categoryType: 'business',
    label: '事業理解・共感',
    children: [
      {
        title: '事業への理解・共感',
        questions: [
          {
            body: '現在ご自身が関わっている事業の戦略や目標を理解していますか？',
          },
          {
            body: '現在ご自身が関わっている事業の戦略や目標に共感していますか？',
          },
        ],
      },
      {
        title: '事業基盤への理解や安心',
        questions: [
          {
            body: 'あなたが関わっている事業には、強みや特徴があると感じますか？',
          },
          {
            body: 'あなたが関わっている事業の業界・市場は、今後の可能性を感じられる状況だと思いますか？',
          },
        ],
      },
      {
        title: '事業の社会的意義',
        questions: [
          {
            body: '現在ご自身が関わっている事業は、社会的に意義のある事業だと思いますか？',
          },
        ],
      },
    ],
  },
  organization: {
    categoryType: 'organization',
    label: '組織理解・共感',
    children: [
      {
        title: '組織ごとの相互理解',
        questions: [
          {
            body: '自部署以外の他部署の業務内容や状況、どんな人がいるかを理解していますか？',
          },
          {
            body: '他部署の業務内容や状況、どんな人がいるかなどの情報を得やすい職場環境（理解できる環境）があると思いますか？',
          },
        ],
      },
      {
        title: '組織の風土',
        questions: [
          {
            body: '従業員の挑戦や失敗が賞賛される組織風土はあると思いますか？',
          },
          {
            body: '部署や役職、年齢や雇用形態などに関わらず、従業員の一人として対等な立場で仕事ができていると思いますか？',
          },
        ],
      },
      {
        title: '組織間のコミュニケーション',
        questions: [
          {
            body: '他部署の人とコミュニケーションを取る機会はありますか？',
          },
          {
            body: '他部署とコミュニケーションが取りやすい環境や風土があると思いますか？（情報共有や交流など）',
          },
        ],
      },
    ],
  },
  boss: {
    categoryType: 'boss',
    label: '上司との関係',
    children: [
      {
        title: '上司との相互理解',
        questions: [
          {
            body: 'あなたの上司は、部署の目標や方針を必要に応じて共有してくれていると思いますか？',
          },
          {
            body: 'あなたの上司は、あなたの業務状況や人となりを理解しようとしてくれていると思いますか？',
          },
          {
            body: 'あなたの上司との間に信頼関係が築けていると思いますか？',
          },
        ],
      },
      {
        title: '上司とのコミュニケーション',
        questions: [
          {
            body: '職場では、上司に気軽に声をかけられる環境がありますか？',
          },
          {
            body: 'あなたには、上司と相談や情報共有のための機会がありますか？',
          },
        ],
      },
      {
        title: '上司からの支援・サポート',
        questions: [
          {
            body: 'あなたの上司は、必要なときに業務上の支援やフォローをしてくれていると思いますか？',
          },
        ],
      },
    ],
  },
  associate: {
    categoryType: 'associate',
    label: '仲間との関係',
    children: [
      {
        title: '自部署の仲間との相互理解',
        questions: [
          {
            body: '現在のチームメンバーの仕事内容や人となりを理解していますか？',
          },
        ],
      },
      {
        title: '自部署内のコミュニケーション',
        questions: [
          {
            body: '現在のチーム内のコミュニケーションは良好に行われていますか？',
          },
        ],
      },
      {
        title: '自部署の支援・サポート',
        questions: [
          {
            body: '現在のチームでは、業務で困った時や分からないことがあった時には、適切な支援やサポートを受けることができますか？',
          },
        ],
      },
    ],
  },
  treatment: {
    categoryType: 'treatment',
    label: '業務環境・待遇',
    children: [
      {
        title: '給与・待遇',
        questions: [
          {
            body: '現在の仕事内容に見合った給与・待遇が得られていると思いますか？',
          },
        ],
      },
      {
        title: '働く環境（オフィス、ハード）',
        questions: [
          {
            body: '仕事を行うための環境は、安全で滞りなく業務できるよう整備されていると思いますか？',
          },
        ],
      },
      {
        title: '福利厚生・その他',
        questions: [
          {
            body: '会社の福利厚生は、適切に運用されていると思いますか？',
          },
        ],
      },
    ],
  },
  recognition: {
    categoryType: 'recognition',
    label: '承認欲求',
    children: [
      {
        title: '自己の仕事内容について',
        questions: [
          {
            body: 'あなたの現在の業務内容は、あなたの能力に対して適切な仕事量だと思いますか？',
          },
          {
            body: 'あなたの現在の業務内容は、あなたの能力に対して適切な難易度だと思いますか？',
          },
          {
            body: 'あなたの現在の業務内容は、あなたにとってやりがいのあるものだと思いますか？',
          },
        ],
      },
      {
        title: 'キャリアパス',
        questions: [
          {
            body: 'あなたの現在の業務内容は、あなたの今後のキャリアにプラスになっていくと思いますか？',
          },
        ],
      },
    ],
  },
  opportunity: {
    categoryType: 'opportunity',
    label: '成長機会',
    children: [
      {
        title: '成長機会・実感',
        questions: [
          {
            body: 'ご自身の能力・スキルが伸びていると実感していますか？',
          },
          {
            body: '現在の職場に貢献していると実感していますか？',
          },
        ],
      },
    ],
  },
};

export const QUESTION_CATEGORY_ICONS = {
  company: categoryCompanyIcon,
  business: categoryBusinessIcon,
  organization: categoryOrganizationIcon,
  boss: categoryBossIcon,
  associate: categoryAssociateIcon,
  treatment: categoryTreatmentIcon,
  recognition: categoryRecognitionIcon,
  opportunity: categoryOpportunityIcon,
} as BracketTypes;

// セグメント定数
export const ENGAGEMENT_SURVEY_SEGMENTS: EngageMentSurveySegmentsType[] = [
  'department',
  'position',
  'age',
  'gender',
  'seniority',
  'employmentType',
  'recruitmentType',
];

export type EngageMentSurveySegmentsType =
  | 'department'
  | 'position'
  | 'age'
  | 'gender'
  | 'seniority'
  | 'employmentType'
  | 'recruitmentType';

export const STATUS_CHANGE_MESSAGE =
  'この診断を停止したいときは、こちらから変更できます。設定はいつでも変更することができます。';

export const SURVEY_CREATE_VALIDATION_MESSAGE = '終了日時は開始日時以降の日時を指定してください。';
